import { render, staticRenderFns } from "./activityClaim.vue?vue&type=template&id=3b04f446&scoped=true"
import script from "./activityClaim.vue?vue&type=script&lang=js"
export * from "./activityClaim.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./activityClaim.vue?vue&type=style&index=1&id=3b04f446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04f446",
  null
  
)

export default component.exports